module.exports = __webpack_public_path__ + "static/media/icon1TB.f47ce947.svg";